import uuid from 'node-uuid'
import moment from 'moment'
import {apiUrl, apiOption, apiResponse, errorResponse} from '../core/fetchz'
import {parseFormat} from '../core/momentz'
import loading from '../core/redux/loading'
import {linkFinder} from '../core/links'
import config from '../config'

const NAMESPACE = 'Provider'
export const PROVIDER_LINKS_LOADED = NAMESPACE + '/ProviderLinksLoaded'
export const PROVIDER_STREAM_LOADED = NAMESPACE + '/ProviderStreamLoaded'
export const PROVIDER_STREAM_QUERIED = NAMESPACE + '/ProviderStreamQueried'
export const PROVIDER_SUGGEST_LOADED = NAMESPACE + '/ProviderSuggestLoaded'
export const PROVIDER_SUGGEST_QUERIED = NAMESPACE + '/ProviderSuggestQueried'
export const PROVIDER_COVERAGE_LOADED = NAMESPACE + '/ProviderCoverageLoaded'
export const PROVIDER_LOADED = NAMESPACE + '/ProviderLoaded'
export const CONTACT_LINKS_LOADED = NAMESPACE + '/ContactLinksLoaded'
export const CONTACT_STREAM_LOADED = NAMESPACE + '/ContactStreamLoaded'
export const CONTACT_STREAM_QUERIED = NAMESPACE + '/ContactStreamQueried'
export const CONTACT_SUGGEST_LOADED = NAMESPACE + '/ContactSuggestLoaded'
export const CONTACT_SUGGEST_QUERIED = NAMESPACE + '/ContactSuggestQueried'
export const CONTACT_LOADED = NAMESPACE + '/ContactLoaded'
export const REFERENCE_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/ReferenceProviderCmdSent'
export const ADD_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/AddProviderContactCmdSent'
export const UPDATE_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/UpdateProviderContactCmdSent'
export const ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT = NAMESPACE + '/AssociateProviderContactWithProviderCompanyCmdSent'
export const ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT = NAMESPACE + '/AssociateProviderContactWithPatrimonyCmdSent'
export const DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT = NAMESPACE + '/DissociateProviderContactFromPatrimonyCmdSent'
export const ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/AssignActivityToProviderContactCmdSent'
export const REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/RemoveActivityFromProviderContactCmdSent'
export const ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/AssignActivityToProviderCompanyCmdSent'
export const UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/UnAssignActivityToProviderCompanyCmdSent'
export const DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT = NAMESPACE + '/DefineUpdateInterventionPeriodForActivityCmdSent'
export const REMOVE_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveInterventionPeriodCmdSent'
export const DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineServiceChargeForInterventionPeriodCmdSent'
export const REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveServiceChargeFromInterventionPeriodCmdSent'
export const DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineInterventionZoneForInterventionPeriodCmdSent'
export const REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveInterventionZoneFromInterventionPeriodCmdSent'
export const DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineCallOutChargesForInterventionPeriodCmdSent'
export const REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveCallOutChargesFromInterventionPeriodCmdSent'
export const SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/SubscribeProviderCompanyToDirectoryForInterventionPeriodCmdSent'
export const DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/DefineContactInfosForProviderCompanyCmdSent'
export const DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineRepairTimelimitForInterventionPeriodCmdSent'
export const REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveRepairTimelimitFromInterventionPeriodCmdSent'
export const DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineInterventionTimelimitForInterventionPeriodCmdSent'
export const REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveInterventionTimelimitFromInterventionPeriodCmdSent'
export const EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/ExcludeOpeningTicketPurposesFromInterventionPeriodCmdSent'
// form actions
export const PROVIDER_CRITERIA_UPDATED = NAMESPACE + '/ProviderCriteriaUpdated'
export const PROVIDER_MINOR_CRITERIA_UPDATED = NAMESPACE + '/ProviderMinorCriteriaUpdated'
export const PROVIDER_MINOR_CRITERIA_RESETTED = NAMESPACE + '/ProviderMinorCriteriaResetted'
export const PROVIDER_COVERAGE_CRITERIA_UPDATED = NAMESPACE + '/ProviderCoverageCriteriaUpdated'
export const CONTACT_CRITERIA_UPDATED = NAMESPACE + '/ContactCriteriaUpdated'
export const CONTACT_FILTER_UPDATED = NAMESPACE + '/ContactFilterUpdated'
export const CONTACT_MINOR_CRITERIA_UPDATED = NAMESPACE + '/ContactMinorCriteriaUpdated'
export const CONTACT_MINOR_CRITERIA_RESET = NAMESPACE + '/ContactMinorCriteriaReset'
export const REFERENCE_PROVIDER_COMPANY_CMD_UPDATED = NAMESPACE + '/ReferenceProviderCompanyCmdUpdated'
export const ADD_PROVIDER_CONTACT_CMD_UPDATED = NAMESPACE + '/AddProviderContactCmdUpdated'
export const UPDATE_PROVIDER_CONTACT_CMD_UPDATED = NAMESPACE + '/UpdateProviderContactCmdUpdated'
export const ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED = NAMESPACE + '/AssociateProviderContactWithProviderCompanyCmdUpdated'
export const ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED = NAMESPACE + '/AssignActivityToProviderCompanyCmdUpdated'
export const DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED = NAMESPACE + '/DefineUpdateInterventionPeriodForActivityCmdUpdated'
export const DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineServiceChargeForInterventionPeriodCmdUpdated'
export const DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineInterventionZoneForInterventionPeriodCmdUpdated'
export const DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineCallOutChargesForInterventionPeriodCmdUpdated'
export const SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/SubscribeProviderCompanyToDirectoryForInterventionPeriodCmdUpdated'
export const DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED = NAMESPACE + '/DefineContactInfosForProviderCompanyCmdUpdated'
export const DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineRepairTimelimitForInterventionPeriodCmdUpdated'
export const DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineInterventionTimelimitForInterventionPeriodCmdUpdated'
export const EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/ExcludeOpeningTicketPurposesFromInterventionPeriodCmdUpdated'

export const DEFAULT_QUERY = {
    range: {offset: 0, limit: 19}
}

export const DEFAULT_PROVIDER_QUERY = {
    ...DEFAULT_QUERY,
    fullText: null,
    activityUid: null,
    filtered: null
}

export const DEFAULT_PROVIDER_COVERAGE_QUERY = {
    zipCodes: null,
    department: null,
    activityUids: null
}

export const DEFAULT_CONTACT_QUERY = {
    ...DEFAULT_QUERY,
    companyUid: null,
    agencyUids: null,
    providerCompanyUid: null,
    patrimonyUids: null,
    activityUids: null,
    openingTicketPurposeUids: null,
    fullText: null
}

export const DEFAULT_CONTACT_STATS_QUERY = {
    from: null,
    to: null
}

export function loadProviderLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/providercompanies', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: PROVIDER_LINKS_LOADED,
            _links: json._links
        }
    }), PROVIDER_LINKS_LOADED)
}

export function queryProviderStream(providerQuery) {
    return loadProviderStream(providerQuery, PROVIDER_STREAM_QUERIED)
}

export function loadProviderStream(providerQuery, action) {
    return loading((state) => {
        const {query} = state.provider

        providerQuery = {
            ...DEFAULT_PROVIDER_QUERY,
            ...query,
            ...providerQuery
        }

        return fetch(apiUrl(config.api.url + '/providercompanies', providerQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || PROVIDER_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                _links: json._links,
                query: providerQuery
            }
        })
    }, action || PROVIDER_STREAM_LOADED)
}

export function queryProviderSuggest(suggestQuery) {
    return loadProviderSuggest(suggestQuery, PROVIDER_SUGGEST_QUERIED)
}

export function loadProviderSuggest(suggestQuery, action) {
    return loading(fetch(apiUrl(config.api.url + '/providercompanies/suggest', suggestQuery), apiOption())
    .then(apiResponse)
    .then(({headers, json}) => {
        return {
            type: action || PROVIDER_SUGGEST_LOADED,
            suggest: json.result
        }
    }), action || PROVIDER_SUGGEST_LOADED)
}

export function loadProviderCoverage(coverageQuery) {
    return loading((state) => {
        const {query} = state.provider.coverage

        coverageQuery = {
            ...DEFAULT_PROVIDER_COVERAGE_QUERY,
            ...query,
            ...coverageQuery
        }

        if (coverageQuery.zipCodes || coverageQuery.department || coverageQuery.city) {
            const {activityUids, zipCodes, department, city, ...body} = coverageQuery
            const option = {
                body: {
                    ...body,
                    activityuids: activityUids && activityUids.map((a) => a.uid) || [],
                    zipcodes: zipCodes && zipCodes.split(/[,;:\s]+/) || undefined,
                    cityuids: city && [city.cityUid] || undefined,
                    department: department && department.departmentNumber || undefined
                }
            }

            return fetch(config.api.url + '/providercompanies/citycoverage', apiOption(option))
            .then(apiResponse)
            .then(({headers, json}) => {
                return {
                    type: PROVIDER_COVERAGE_LOADED,
                    coverage: json.cities,
                    query: coverageQuery
                }
            })
        } else {
            const {activityUids, ...body} = coverageQuery
            const option = {
                body: {
                    ...body,
                    activityuids: activityUids && activityUids.map((a) => a.uid) || []
                }
            }

            return fetch(config.api.url + '/providercompanies/departmentcoverage', apiOption(option))
            .then(apiResponse)
            .then(({headers, json}) => {
                return {
                    type: PROVIDER_COVERAGE_LOADED,
                    coverage: json.departments,
                    query: coverageQuery
                }
            })
        }
    }, PROVIDER_COVERAGE_LOADED)
}

export function loadProvider(id) {
    return loading((state) => {
        const {provider} = state.provider
        id = id || (provider && provider.uid)

        return fetch(config.api.url + '/providercompanies/' + id, apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: PROVIDER_LOADED,
                provider: json,
            }
        })
    }, PROVIDER_LOADED)
}

export function loadContactLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/providercontacts', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: CONTACT_LINKS_LOADED,
            _links: json._links
        }
    }), CONTACT_LINKS_LOADED)
}

export function queryContactStream(contactQuery) {
    return loadContactStream(contactQuery, CONTACT_STREAM_QUERIED)
}

export function loadContactStream(contactQuery, action) {
    return loading((state) => {
        const {query} = state.provider.contact

        contactQuery = {
            ...DEFAULT_CONTACT_QUERY,
            ...query,
            ...contactQuery
        }

        return fetch(apiUrl(config.api.url + '/providercontacts', contactQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || CONTACT_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                _links: json._links,
                query: contactQuery
            }
        })
    }, action || CONTACT_STREAM_LOADED)
}

export function queryContactSuggest(suggestQuery) {
    return loadContactSuggest(suggestQuery, CONTACT_SUGGEST_QUERIED)
}

export function loadContactSuggest(suggestQuery, action) {
    return loading(fetch(apiUrl(config.api.url + '/providercontacts/suggest', suggestQuery), apiOption())
    .then(apiResponse)
    .then(({headers, json}) => {
        return {
            type: action || CONTACT_SUGGEST_LOADED,
            suggest: json.result
        }
    }), action || CONTACT_SUGGEST_LOADED)
}

export function loadContact(id, query) {
    return loading((state) => {
        const {contact, contactStatsQuery} = state.provider.contact
        id = id || (contact && contact.uid)

        query = {
            ...DEFAULT_CONTACT_STATS_QUERY,
            ...contactStatsQuery,
            ...query
        }

        const contactPromise = fetch(config.api.url + '/providercontacts/' + id, apiOption()).then(apiResponse)
        const statsPromise = fetch(apiUrl(config.api.url + '/providercontacts/' + id + '/stats', query), apiOption()).then(apiResponse)

        return Promise.all([contactPromise, statsPromise])
        .then(([contactResponse, statsResponse]) => {
            return {
                type: CONTACT_LOADED,
                contact: contactResponse.json,
                contactStats: statsResponse.json,
                contactStatsQuery: query
            }
        })
    }, CONTACT_LOADED)
}

export function sendReferenceProviderCompanyCmd() {
    return loading((state) => {
        const {referenceProviderCompanyCmd} = state.provider
        const {label, ...cmd} = referenceProviderCompanyCmd

        const option = {
            body: {
                processUid: uuid.v4(),
                createdDate: new Date().toISOString().slice(0,10),
                commandType: 'ReferenceProviderCompany',
                name: label,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercompanies', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: REFERENCE_PROVIDER_COMPANY_CMD_SENT,
                events: json.events
            }
        })
    }, REFERENCE_PROVIDER_COMPANY_CMD_SENT)
}

export function sendAddProviderContactCmd(providerId) {
    return loading((state) => {
        const {addProviderContactCmd} = state.provider
        const {companyUid, providerCompanyUid, namez, phones, fax, emails, ...cmd} = addProviderContactCmd

        const option = {
            body: {
                processUid: uuid.v4(),
                date: new Date().toISOString().slice(0,10),
                companyUid: companyUid && companyUid.uid,
                providerCompanyUid: providerId || (providerCompanyUid && providerCompanyUid.uid),
                name: namez,
                phones: phones || [],
                fax: fax || [],
                emails: emails || [],
                commandType: 'AddProviderContact',
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercontacts', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_PROVIDER_CONTACT_CMD_SENT
            }
        })
    }, ADD_PROVIDER_CONTACT_CMD_SENT)
}

export function sendUpdateProviderContactCmd() {
    return loading((state) => {
        const {contact} = state.provider.contact
        const {updateProviderContactCmd} = state.provider
        const {namez, phones, fax, emails, ...cmd} = updateProviderContactCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date().toISOString().slice(0,10),
                name: namez,
                phones: phones || [],
                fax: fax || [],
                emails: emails || [],
                commandType: 'UpdateProviderContact',
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_PROVIDER_CONTACT_CMD_SENT
            }
        })
    }, UPDATE_PROVIDER_CONTACT_CMD_SENT)
}

export function sendAssociateProviderContactWithProviderCompanyCmd() {
    return loading((state) => {
        const {contact} = state.provider.contact
        const {associateProviderContactWithProviderCompanyCmd} = state.provider
        const {providerCompanyUid, ...cmd} = associateProviderContactWithProviderCompanyCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AssociateProviderContactWithProviderCompany',
                providerCompanyUid: providerCompanyUid.uid,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT
            }
        })
    }, ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT)
}

export function sendAssociateProviderContactWithPatrimonyCmd(patrimonyUid) {
    return loading((state) => {
        const {contact} = state.provider.contact

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AssociateProviderContactWithPatrimony',
                patrimonyUid: patrimonyUid
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT
            }
        })
    }, ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT)
}

export function sendDissociateProviderContactFromPatrimonyCmd(patrimonyUid) {
    return loading((state) => {
        const {contact} = state.provider.contact

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DissociateProviderContactFromPatrimony',
                patrimonyUid: patrimonyUid
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT
            }
        })
    }, DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT)
}

export function sendAssignActivityToProviderContactCmd(activityUid, incidentTypeUids, contactUid) {
    return loading((state) => {
        const {contact} = state.provider.contact
        activityUid = activityUid.uid || activityUid
        incidentTypeUids = incidentTypeUids.map((it) => it.uid || it)
        contactUid = (contactUid && contactUid.uid) || contactUid || contact.uid

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AssignActivityToProviderContact',
                activityUid: activityUid,
                includedIncidentTypes: incidentTypeUids
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contactUid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT
            }
        })
    }, ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT)
}

export function sendRemoveActivityFromProviderContactCmd(activityUid) {
    return loading((state) => {
        const {contact} = state.provider.contact
        activityUid = activityUid.uid || activityUid

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveActivityFromProviderContact',
                activityUid: activityUid
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT
            }
        })
    }, REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT)
}

export function sendAssignActivityToProviderCompanyCmd() {
    return loading((state) => {
        const {provider, assignActivityToProviderCompanyCmd} = state.provider
        const {activityUid, ...cmd} = assignActivityToProviderCompanyCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AssignActivityToProviderCompany',
                activityUid: activityUid && activityUid.uid,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT
            }
        })
    }, ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT)
}

export function sendUnAssignActivityFromProviderCompanyCmd(activityId) {
    return loading((state) => {
        const {provider} = state.provider

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'UnAssignActivityFromProviderCompany',
                activityUid: activityId
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT
            }
        })
    }, UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT)
}

export function sendDefineUpdateInterventionPeriodForActivityCmd(_links, activityId, defineUpdateCmd) {
    return loading((state) => {
        const {defineUpdateInterventionPeriodForActivityCmd} = state.provider
        const {period: {periodRanges, exclusions, days, timeSlot, startDate, endDate, ...period}, ...cmd} = defineUpdateCmd || defineUpdateInterventionPeriodForActivityCmd

        function periodMapper(period) {
            return {
                start: moment(period.start, parseFormat(period.start, 'HH:mm:ss')).format('HH:mm:ss'),
                end: moment(period.end, parseFormat(period.end, 'HH:mm:ss')).format('HH:mm:ss')
            }
        }

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                activityUid: activityId,
                period: {
                    periodRanges: periodRanges && periodRanges.map((periodRange) => ({
                        ...periodRange,
                        timeSlot: {
                            ...periodRange.timeSlot,
                            periods: periodRange.timeSlot.periods && periodRange.timeSlot.periods.map(periodMapper)
                        }
                    })),
                    exclusions: exclusions && exclusions.map((exclusion) => ({
                        ...exclusion,
                        days: exclusion.days.map((d) => moment(d).format('YYYY-MM-DD')),
                        timeSlot: {
                            ...exclusion.timeSlot,
                            periods: exclusion.timeSlot.periods && exclusion.timeSlot.periods.map(periodMapper)
                        }
                    })) || [],
                    days: days && days.map((d) => moment(d).format('YYYY-MM-DD')),
                    timeSlot: timeSlot && {
                        ...timeSlot,
                        periods: timeSlot.periods && timeSlot.periods.map(periodMapper)
                    },
                    startDate: startDate && moment(startDate).format('YYYY-MM-DD'),
                    endDate: endDate && moment(endDate).format('YYYY-MM-DD'),
                    ...period
                },
                ...cmd
            }
        }

        return fetch(_links.find(linkFinder(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])).href, apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT,
                events: json.events
            }
        })
    }, DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT)
}

export function sendRemoveInterventionPeriodCmd(_links, activityId, interventionPeriodId) {
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveInterventionPeriod',
                activityUid: activityId,
                interventionPeriodUid: interventionPeriodId
            }
        }

        return loading(fetch(_links.find(linkFinder('RemoveInterventionPeriod')).href, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_INTERVENTION_PERIOD_CMD_SENT
            }
        }), REMOVE_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendDefineServiceChargeForInterventionPeriodCmd(activityId, interventionPeriodId, defineCmd) {
    return loading((state) => {
        const {provider, defineServiceChargeForInterventionPeriodCmd} = state.provider
        const {charge, ...cmd} = defineCmd || defineServiceChargeForInterventionPeriodCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DefineServiceChargeForInterventionPeriod',
                activityUid: activityId,
                interventionPeriodUid: interventionPeriodId,
                charge: {
                    currency: 'EURO',
                    chargeType: 'FixChargeValue',
                    ...charge
                },
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendRemoveServiceChargeFromInterventionPeriodCmd(activityId, interventionPeriodId) {
    return loading((state) => {
        const {provider} = state.provider

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveServiceChargeFromInterventionPeriod',
                activityUid: activityId,
                interventionPeriodUid: interventionPeriodId
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendDefineInterventionZoneForInterventionPeriodCmd(_links, activityId, interventionPeriodId, defineCmd) {
    return loading((state) => {
        const {defineInterventionZoneForInterventionPeriodCmd} = state.provider
        const {zone: {address, range}, ...cmd} = defineCmd || defineInterventionZoneForInterventionPeriodCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DefineInterventionZoneForInterventionPeriod',
                activityUid: activityId,
                interventionPeriodUid: interventionPeriodId,
                zone: {
                    address: {
                        ...address,
                        addressType: 'PlaceId'
                    },
                    range: {
                        ...range,
                        unit: 'meter'
                    },
                    zoneType: 'AddressZone'
                },
                ...cmd
            }
        }

        return fetch(_links.find(linkFinder('DefineInterventionZoneForInterventionPeriod')).href, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendRemoveInterventionZoneFromInterventionPeriodCmd(_links, activityId, interventionPeriodId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'RemoveInterventionZoneFromInterventionPeriod',
            activityUid: activityId,
            interventionPeriodUid: interventionPeriodId,
        }
    }

    return loading(fetch(_links.find(linkFinder('RemoveInterventionZoneFromInterventionPeriod')).href, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT
        }
    }), REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendDefineCallOutChargesForInterventionPeriodCmd(activityId, interventionPeriodId, defineCmd) {
    return loading((state) => {
        const {provider, defineCallOutChargesForInterventionPeriodCmd} = state.provider
        const {callOutCharges, ...cmd} = defineCmd || defineCallOutChargesForInterventionPeriodCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DefineCallOutChargesForInterventionPeriod',
                activityUid: activityId,
                interventionPeriodUid: interventionPeriodId,
                callOutCharges: callOutCharges && callOutCharges.map((callOutCharge) => ({
                    range: {
                        unit: 'meter',
                        ...callOutCharge.range
                    },
                    charge: {
                        currency: 'EURO',
                        chargeType: 'FixChargeValue',
                        ...callOutCharge.charge
                    }
                })),
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendRemoveCallOutChargesFromInterventionPeriodCmd(activityId, interventionPeriodId) {
    return loading((state) => {
        const {provider} = state.provider

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveCallOutChargesFromInterventionPeriod',
                activityUid: activityId,
                interventionPeriodUid: interventionPeriodId,
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(activityId, interventionPeriodId, subscribeCmd) {
    return loading((state) => {
        const {provider, subscribeProviderCompanyToDirectoryForInterventionPeriodCmd} = state.provider
        const cmd = subscribeCmd || subscribeProviderCompanyToDirectoryForInterventionPeriodCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'SubscribeProviderCompanyToDirectoryForInterventionPeriod',
                activityUid: activityId,
                interventionPeriodUid: interventionPeriodId,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendDefineContactInfosForProviderCompanyCmd() {
    return loading((state) => {
        const {provider, defineContactInfosForProviderCompanyCmd} = state.provider
        const {namez, phones, fax, emails, ...cmd} = defineContactInfosForProviderCompanyCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                name: namez,
                phones: phones || [],
                fax: fax || [],
                emails: emails || [],
                commandType: 'DefineContactInfosForProviderCompany',
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercompanies/' + provider.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT
            }
        })
    }, DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT)
}

export function sendDefineRepairTimelimitForInterventionPeriodCmd(interventionPeriodId, defineCmd) {
    return loading((state) => {
        const {defineRepairTimelimitForInterventionPeriodCmd} = state.provider
        const {contact} = state.provider.contact
        const {timelimits, ...cmd} = defineCmd || defineRepairTimelimitForInterventionPeriodCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DefineRepairTimelimitForInterventionPeriod',
                interventionPeriodUid: interventionPeriodId,
                timelimits: timelimits && timelimits.map((timelimit) => ({
                    ...timelimit,
                    timelimit: {
                        unit: 'milliseconds',
                        ...timelimit.timelimit
                    }
                })),
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendRemoveRepairTimelimitFromInterventionPeriodCmd(interventionPeriodId) {
    return loading((state) => {
        const {contact} = state.provider.contact

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveRepairTimelimitFromInterventionPeriod',
                interventionPeriodUid: interventionPeriodId
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendDefineInterventionTimelimitForInterventionPeriodCmd(interventionPeriodId, defineCmd) {
    return loading((state) => {
        const {defineInterventionTimelimitForInterventionPeriodCmd} = state.provider
        const {contact} = state.provider.contact
        const {timelimits, ...cmd} = defineCmd || defineInterventionTimelimitForInterventionPeriodCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DefineInterventionTimelimitForInterventionPeriod',
                interventionPeriodUid: interventionPeriodId,
                timelimits: timelimits && timelimits.map((timelimit) => ({
                    ...timelimit,
                    timelimit: {
                        unit: 'milliseconds',
                        ...timelimit.timelimit
                    }
                })),
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendRemoveInterventionTimelimitFromInterventionPeriodCmd(interventionPeriodId) {
    return loading((state) => {
        const {contact} = state.provider.contact

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveInterventionTimelimitFromInterventionPeriod',
                interventionPeriodUid: interventionPeriodId
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT)
}

export function sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd(interventionPeriodId, excludeCmd) {
    return loading((state) => {
        const {excludeOpeningTicketPurposesFromInterventionPeriodCmd} = state.provider
        const {contact} = state.provider.contact
        const cmd = excludeCmd || excludeOpeningTicketPurposesFromInterventionPeriodCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'ExcludeOpeningTicketPurposesFromInterventionPeriod',
                interventionPeriodUid: interventionPeriodId,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/providercontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT
            }
        })
    }, EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT)
}

export function updateAddProviderContactCmd(cmd) {
    return {
        type: ADD_PROVIDER_CONTACT_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateUpdateProviderContactCmd(cmd) {
    return {
        type: UPDATE_PROVIDER_CONTACT_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateAssociateProviderContactWithProviderCompanyCmd(cmd) {
    return {
        type: ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateDefineUpdateInterventionPeriodForActivityCmd(cmd) {
    return {
        type: DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateDefineServiceChargeForInterventionPeriodCmd(cmd) {
    return {
        type: DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateDefineInterventionZoneForInterventionPeriodCmd(cmd) {
    return {
        type: DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateDefineCallOutChargesForInterventionPeriodCmd(cmd) {
    return {
        type: DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(cmd) {
    return {
        type: SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateDefineContactInfosForProviderCompanyCmd(cmd) {
    return {
        type: DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateDefineRepairTimelimitForInterventionPeriodCmd(cmd) {
    return {
        type: DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateDefineInterventionTimelimitForInterventionPeriodCmd(cmd) {
    return {
        type: DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd(cmd) {
    return {
        type: EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateProviderCriteria(criteria) {
    return {
        type: PROVIDER_CRITERIA_UPDATED,
        criteria: criteria
    }
}

export function updateProviderCoverageCriteria(criteria) {
    return {
        type: PROVIDER_COVERAGE_CRITERIA_UPDATED,
        criteria: criteria
    }
}

export function updateProviderMinorCriteria(minorCriteria) {
    return {
        type: PROVIDER_MINOR_CRITERIA_UPDATED,
        minorCriteria: minorCriteria
    }
}

export function resetProviderMinorCriteria() {
    return {
        type: PROVIDER_MINOR_CRITERIA_RESETTED
    }
}

export function updateContactMinorCriteria(minorCriteria) {
    return {
        type: CONTACT_MINOR_CRITERIA_UPDATED,
        minorCriteria: minorCriteria
    }
}

export function resetContactMinorCriteria() {
    return {
        type: CONTACT_MINOR_CRITERIA_RESET
    }
}



// WEBPACK FOOTER //
// ./lib/provider/actions.js